module.exports = __webpack_public_path__ + "img/ap-mockup.906217cf.jpg";